import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useUserHoldingsEntitlement } from "./UserHoldingsEntitlementContext";
import { IS_STANDALONE } from "../../standalone/config";

/** 跳转「持仓复盘 / 我的持仓」主页面 */
export function useUserHoldingsNavigate(spaceId: string) {
  const navigate = useNavigate();
  const { holdingsModule } = useUserHoldingsEntitlement();

  return useCallback(() => {
    if (IS_STANDALONE) {
      navigate("/tactik/holdings");
      return;
    }
    const routeKey = holdingsModule?.spaceProductId?.trim();
    if (!routeKey) {
      return;
    }
    navigate(`/space/${spaceId}/${routeKey}`);
  }, [holdingsModule?.spaceProductId, navigate, spaceId]);
}
